import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import Dashboard from '../pages/Dashboard';
import FormBuilder from '../pages/FormBuilder';
import FormList from '../pages/FormList/FormList';
import Settings from '../pages/Settings';
import PublicForm from '../pages/PublicForm';
import Analytics from '../pages/Answers/Answers';
import Profile from '../pages/Profile';
import Login from '../pages/Login';
import CreateFolder from '../pages/Folder/CreateFolder';
import ArchivedForms from '../pages/ArchivedForms';
import DeletedItems from '../pages/DeletedItems';
import UserManagement from '../pages/UserManagement';
import UserDefinition from '../pages/UserManagement/UserDefinition';
import UserLogin from '../pages/UserManagement/UserLogin';
import UserDashboard from '../pages/UserManagement/UserDashboard';
import FormResponseDetail from '../pages/UserManagement/FormResponseDetail';
import UserForm from '../pages/UserManagement/UserForm';
/* import FormLink from '../pages/UserManagement/FormLink'; */

import { PrivateRoute, FormUserRoute, AnyUserRoute } from './PrivateRoute';
import FormEdit from '../pages/FormEdit';
import FormLink from '../components/form-builder/FormLink';
import NotFoundPage from '../pages/NotFoundPage';
import FolderManager from '../pages/Folder/FolderManager';
import SupportPage from '../pages/SupportPage';
import FormPdfManager from '../pages/FormPdfManager';
import FormResponsePreview from '../pages/FormResponsePreview';
import PublicFormView from '../pages/PublicFormView';
import PublicSpreadsheetView from '../pages/PublicSpreadsheetView';

import SpreadsheetBuilder from '../pages/Spreadsheet/SpreadsheetBuilder';
import SpreadsheetView from '../pages/Spreadsheet/SpreadsheetView';
import SpreadsheetEdit from '../pages/Spreadsheet/SpreadsheetEdit';
import Tables from '../pages/Spreadsheet/Tables';

import EmissionFactorsAdminPage from '../pages/CarbonFootPrint/EmissionFactorsAdminPage';

// Karbon Ayak İzi Modülü
import CarbonCalculator from '../pages/CarbonFootPrint/CarbonCalculator';
import EmissionFactorsAdmin from '../pages/CarbonFootPrint/EmissionFactorsAdmin';
import TourismCarbonCalculatorPage from '../pages/CarbonFootPrint/TourismCarbonCalculatorPage';

/* import FormResponses from '../pages/FormResponses';
import FormResponsesList from './components/FormResponsesList'; */

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes - herkes erişebilir */}
      <Route path="/login" element={<Login />} />
      <Route path="/user-login" element={<UserLogin />} />
      <Route path="/link/:formId" element={<FormLink />} />
      <Route path="/form/:formId" element={<Layout><PublicForm /></Layout>} />
      <Route path="/support" element={<Layout><SupportPage /></Layout>} />
      <Route path="/form-response-preview/:id" element={<FormResponsePreview />} />

      {/* Public Form ve Spreadsheet Görüntüleme - Login gerektirmez */}
      <Route path="/public-form/:token" element={<PublicFormView />} />
      <Route path="/public-spreadsheet/:token" element={<PublicSpreadsheetView />} />

      {/* Panel kullanıcıları için korumalı rotalar */}
      <Route path="/" element={<PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>} />
      <Route path="/homepage" element={<Navigate to="/" />} />
      <Route path="/form-builder" element={<PrivateRoute><Layout><FormBuilder /></Layout></PrivateRoute>} />
      <Route path="/form-builder/:formId" element={<PrivateRoute><Layout><FormBuilder /></Layout></PrivateRoute>} />
      <Route path="/spreadsheet" element={<PrivateRoute><Layout><SpreadsheetBuilder /></Layout></PrivateRoute>} />
      <Route path="/spreadsheet/:formId" element={<PrivateRoute><Layout><SpreadsheetView /></Layout></PrivateRoute>} />
      <Route path="/spreadsheet-edit/:formId" element={<PrivateRoute><Layout><SpreadsheetEdit /></Layout></PrivateRoute>} />
      <Route path="/tables" element={<PrivateRoute><Layout><Tables /></Layout></PrivateRoute>} />
      <Route path="/forms" element={<PrivateRoute><Layout><FormList /></Layout></PrivateRoute>} />
      <Route path="/archived-forms" element={<PrivateRoute><Layout><ArchivedForms /></Layout></PrivateRoute>} />
      <Route path="/deleted-items" element={<PrivateRoute><Layout><DeletedItems /></Layout></PrivateRoute>} />

      {/* Karbon Ayak İzi ve Sürdürülebilirlik Rotaları */}
      <Route path="/carbon-calculator" element={<PrivateRoute><Layout><CarbonCalculator /></Layout></PrivateRoute>} />
      <Route path="/tourism-carbon" element={<PrivateRoute><Layout><TourismCarbonCalculatorPage /></Layout></PrivateRoute>} />
      <Route path="/emission-factors-admin" element={<PrivateRoute><Layout><EmissionFactorsAdminPage /></Layout></PrivateRoute>} />

      <Route path="/settings" element={<PrivateRoute><Layout><Settings /></Layout></PrivateRoute>} />
      <Route path="/answers" element={<PrivateRoute><Layout><Analytics /></Layout></PrivateRoute>} />
      <Route path="/profile" element={<PrivateRoute><Layout><Profile /></Layout></PrivateRoute>} />
      <Route path="/create-folder" element={<PrivateRoute><Layout><CreateFolder /></Layout></PrivateRoute>} />
      <Route path="/folders" element={<PrivateRoute><Layout><FolderManager /></Layout></PrivateRoute>} />
      <Route path="/user-management" element={<PrivateRoute><UserManagement /></PrivateRoute>} />
      <Route path="/user-definition" element={<PrivateRoute><Layout><UserDefinition /></Layout></PrivateRoute>} />
      <Route path="/form-edit/:formId" element={<PrivateRoute><Layout><FormEdit /></Layout></PrivateRoute>} />
      <Route path="/forms/:formId/pdf" element={<FormPdfManager />} />
      <Route path="/pdf-manager/:formId" element={<Layout><FormPdfManager /></Layout>} />

      {/* Form kullanıcıları için korumalı rotalar */}
      <Route path="/user-dashboard" element={<FormUserRoute><UserDashboard /></FormUserRoute>} />
      {/* <Route path="/user-form/:formId" element={<FormUserRoute><UserForm /></FormUserRoute>} /> */}
      <Route path="/user-form/:formId" element={<UserForm />} />
      <Route path="/form-response/:responseId" element={<FormUserRoute><FormResponseDetail /></FormUserRoute>} />

      {/* Catch all route */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
